/**
 * @name DataTracker 管理后台用户浏览统计工具
 * @param 天眼
 * @author winson 654874992@qq.com
 * @return 获取DataTracker里面的统计工具
 */
import { eventDelegate, removeEventDelegate, getScript } from "./jqUtils";
import Store from 'store';

// tslint:disable
const DataTracker = {
    _delegateClick:null,
    _IsInitialed: 0,
    initTools: function (param) {
        if (this._IsInitialed) {
          return;
        }
        this._IsInitialed = 1;
        // this.skapp(); //安装天眼埋点
    },
    //发送独立事件信息
    singleTrackEvent: function (param) {
        //没有初始化，初始化插件
        // if (!this._SKAPP) {
        //   this.initTools();
        // }
        // this.sendEventLog(param);
    },
    sendEventLog: function (param) {
        const sessionInfo = Store.get('sessionInfo') || {};
        // 天眼埋点
        if (this._SKAPP && this._SKAPP.onEvent) {
         const mapPara = {
            ...param.mapkv,
            user_id: sessionInfo.userId || ''
         };
          this._SKAPP.onEvent(
            param.category || "",
            param.label || "",
            mapPara
          );
        }
    },
    startTrackEvent: function () {
        // //没有初始化，初始化插件
        // if (!this._IsInitialed) {
        //   this.initTools();
        // }
        // let $this = this;
        // function resolveEvent(target) {
        //     if (target.hasAttribute && target.hasAttribute("data-event-category")) {
        //     // 获取事件属性
        //     const category = target.getAttribute("data-event-category") || "";
        //     if (!category || category === "") {
        //         return;
        //     }
        //     const label = target.getAttribute("data-event-label") || "";
        //     const value = target.getAttribute("data-event-value") || "";
        //     const mapkvStr = target.getAttribute("data-event-mapkv") || '{}';
        //     const mapkv = JSON.parse(mapkvStr);
        //     const param = { category, label, value, mapkv };
        //     $this.sendEventLog(param);

        //     }
        // }
        // // 针对单击事件的处理

        // this._delegateClick = eventDelegate("body", "[data-event-category]", 'click', function (e) {
        //     // 拿到事件发生的节点
        //     const target = this;
        //     resolveEvent(target);
        // }
        // );
    },
    stopTrackEvent: function () {
        // removeEventDelegate("body","click",this._delegateClick);
    },

    _SKAPP: window.SKAPP || null, //天眼统计
    skapp: function () {
        if (window.SKAPP) {
            this._SKAPP = window.SKAPP;
        } else {
            window.pingan_sdk_appid = this.getAppid();
            window.pingan_sdk_vn = "v3.0";
            window.pingan_sdk_vc = "18.2.2";

            let scriptSrc = "https://iobs02.pingan.com.cn/download/eits-access-dmz-prd/PAD_H5_SDK_3.1.5_vr1";
            getScript(scriptSrc, () => {
                this._SKAPP = window.SKAPP || null;
            });
        }
    },

    getAppid:function(){
        let url = window.location.href.toUpperCase();
        let appid = 'C0F67EF0E69D487CD5200E86A0BF0FF7';
        if(url.indexOf('TEST') >= 0){
            appid = 'C0F67EF0E69D487CD5200E86A0BF0FF7';
        }else {
            appid = '24986EB6514CE790B363EFB873F97C83';
        }
        return appid;
    },


};
export default DataTracker;
// module.exports = DataTracker;

